<template>
    <div class="container">
      <h1>Markdown CheatSheet</h1>
      <p class="description">Comandos essenciais do Markdown para formatação de texto e estruturação de documentos.</p>
  
      <div class="cheat-sheet">
        <!-- Primeira Coluna -->
        <div class="column">
          <h2>📌 Formatação de Texto</h2>
          <p><b>Negrito:</b></p>
          <code>**Texto em negrito**</code>
  
          <p><b>Itálico:</b></p>
          <code>*Texto em itálico*</code>
  
          <p><b>Negrito + Itálico:</b></p>
          <code>***Texto negrito e itálico***</code>
  
          <p><b>Texto Riscado:</b></p>
          <code>~~Texto riscado~~</code>
  
          <h2>📌 Títulos</h2>
          <p><b>Diferentes níveis de título:</b></p>
          <code>
            # Título 1 <br>
            ## Título 2 <br>
            ### Título 3 <br>
            #### Título 4 <br>
            ##### Título 5 <br>
            ###### Título 6
          </code>
  
          <h2>📌 Listas</h2>
          <p><b>Lista Não Ordenada:</b></p>
          <code>
            - Item 1 <br>
            - Item 2 <br>
            - Item 3
          </code>
  
          <p><b>Lista Ordenada:</b></p>
          <code>
            1. Primeiro item <br>
            2. Segundo item <br>
            3. Terceiro item
          </code>
        </div>
  
        <!-- Segunda Coluna -->
        <div class="column">
          <h2>📌 Links e Imagens</h2>
          <p><b>Inserir um link:</b></p>
          <code>[Texto do link](https://exemplo.com)</code>
  
          <p><b>Inserir uma imagem:</b></p>
          <code>![Texto alternativo](https://exemplo.com/imagem.jpg)</code>
  
          <h2>📌 Citações e Código</h2>
          <p><b>Citação:</b></p>
          <code>> Isto é uma citação.</code>
  
          <p><b>Bloco de Código:</b></p>
          <code>
            ```python <br>
            print("Olá, Markdown!") <br>
            ```
          </code>
  
          <h2>📌 Tabelas</h2>
          <p><b>Criar uma tabela:</b></p>
          <code>
            | Nome  | Idade | Cidade  | <br>
            |-------|-------|---------| <br>
            | João  | 25    | SP      | <br>
            | Maria | 30    | RJ      |
          </code>
        </div>
      </div>
    </div>
  </template>
  
  <style scoped>
  .container {
    max-width: 900px;
    margin: auto;
    padding: 20px;
    text-align: center;
    font-family: "Arial", sans-serif;
  }
  
  h1 {
    font-size: 24px;
    margin-bottom: 10px;
  }
  
  .description {
    font-size: 16px;
    color: #555;
    margin-bottom: 20px;
  }
  
  .cheat-sheet {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }
  
  .column {
    width: 48%;
    background: #f8f9fa;
    padding: 20px;
    border-radius: 8px;
    text-align: left;
    line-height: 1.6;
  }
  
  h2 {
    font-size: 18px;
    margin-bottom: 10px;
    color: #007bff;
  }
  
  p {
    font-size: 14px;
    margin: 8px 0;
  }
  
  code {
    background: #e3e3e3;
    display: block;
    padding: 10px;
    border-radius: 5px;
    font-family: monospace;
    white-space: pre-line;
  }
  </style>
  